


import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import LoaderComponent from '@/shared/components/Loader.vue';
import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";
import SuccessMessageComponent from "@/shared/components/SuccessMessage.vue";
import Field from '../fields/Field.vue';
import EditButton from '../buttons/EditButton.vue';
import AddressEdit from '../address/AddressEdit.vue';
import PhoneNumberEdit from '../phonenumber/PhoneNumberEdit.vue';

import HttpService from "@/shared/services/http-service";
import UserProfileService from "../../services/user-profile-service";

import { PhoneNumber } from "../../models/user-profile-viewmodel";

import LinkDirective from '@/shared/directives/link-directive';
import { getUrlTarget, getRel } from '@/shared/services/link-service';

@Component({
    components: {
        LoaderComponent,
        ErrorMessagesComponent,
        SuccessMessageComponent,
        Field,
        EditButton,
        AddressEdit,
        PhoneNumberEdit
    },
    computed: {
        ...mapGetters([
            "config",
            "studies", 
            "faculties", 
            "universityEmail", 
            "personalEmail", 
            "residentialAddress",
            "correspondenceAddress",
            "temporaryAddress",
            "ice",
            "phoneNumbers",
            "personalInfo",
            "countryPhoneCode",
            "sectionLoading",
            "sectionFormOpen",
            "sectionError",
            "sectionSuccess",
            "countryName",
            "profileData",
            "countries",
            "formData",
            "formSection"
        ])
    },
    directives: {
        LinkDirective
    }
})
export default class FormComponent extends Vue {
    getPhoneNumber(phone: PhoneNumber): string {
        return `${this.$store.getters.countryPhoneCode(phone.countryCode)} ${phone.number}`;
    }
    
    public replaceString(text: string, placeholder: string, placeholderText: string, url: string): string {
        if(text) {
            if (url) {
                return text.replace(placeholder, `<a target="${getUrlTarget(url)}" rel="${getRel(url)}" href="${url}" class="vuw-underline vuw-text-primary-1">${placeholderText}</a>`);
            }
            return text.replace(placeholder, placeholderText);
        } return '';
    }

    public saveButtonActive(type: string): boolean {
        if (type === 'phoneNumbers') {
            return this.$store.getters.phoneNumbersDataModified;
        }

        if (type === 'ice') {
            return this.$store.getters.iceDataModified;
        }

        if (type === 'correspondence') {
            return this.$store.getters.correspondenceDataModified;
        }

        if (type === 'temporary') {
            return this.$store.getters.temporaryDataModified;
        }

        return true;
    }

    public saveSection(type: string): void {
        this.$store.commit('setFormSectionError', {type: type, status: false});
        this.$store.commit('setFormSectionSubmitted', {type: type, status: true});
        this.$store.commit('setFormSectionFieldErrors', {type: type, errors: []});
        this.loadingUpdate(type, true);
        this.sendUpdateData(type);
    }

    public successUpdate(type: string): void {
        this.$store.commit('setFormSectionOpen', {type: type, status: false});
        this.$store.commit('setFormSectionSuccess', {type: type, status: true});
    }

    public errorUpdate(type: string, errorMessage: any): void {
        this.$store.commit('setFormSectionError', {type: type, status: true});
        console.error('Error message:', errorMessage);
    }

    public loadingUpdate(type: string, status: boolean):void {
        this.$store.commit('setFormSectionLoading', {type: type, status: status})
    }

    public sendUpdateData(type: string): void {
        if (type === 'phoneNumbers') {
            UserProfileService.updateUserProfilePhoneNumbers(this.$store.getters.formData.phoneNumbers, HttpService)
                .then(() => this.successUpdate(type))
                .catch(error => this.errorUpdate(type, error))
                .finally(() => this.loadingUpdate(type, false));
        }

        if (type === 'temporary' || type === 'correspondence') {
            this.$store.getters.formData[type].type = type === 'temporary' ? 'Visiting': 'Correspondence';
            
            if (this.$store.getters.addressValid(this.$store.getters.formData[type])) {
                UserProfileService.updateUserProfileAddress(this.$store.getters.config, this.$store.getters.formData[type], HttpService)
                    .then((result: any) => {
                        if(result.errors) {
                            this.$store.commit('setFormSectionFieldErrors', {type: type, errors: result.errors});
                        } else {
                            this.successUpdate(type)
                        }
                    })
                    .catch(error => this.errorUpdate(type, error))
                    .finally(() => this.loadingUpdate(type, false));
            } else {
                this.loadingUpdate(type, false);
            }
        }

        if (type === 'ice') {
            UserProfileService.updateUserProfileIce({phoneNumbers: this.$store.getters.formData.ice}, HttpService)
                .then(() => this.successUpdate(type))
                .catch(error => this.errorUpdate(type, error))
                .finally(() => this.loadingUpdate(type, false));
        }
    }
}
